// This is JS code shared among all views.
import $ from "jquery";

$(function () {
  console.log("inspiratiepunten.js Ready");

  // Switch between view
  // $('.button-iprt-view').on('click', function (e) {
  //   e.preventDefault();

  //   const view = $(this).data('view');

  //   document.getElementById("iprt-page-transition").style.display = "block";
  //   document.getElementById("iprt-page-transition").style.pointerEvents =
  //     "auto";
  //   setTimeout(() => {
  //     document.getElementById("iprt-page-transition").classList.add("active");

  //     setTimeout(() => {
  //       window.open('/inspiratiepunten?view=' + view, '_self');
  //     }, 1500);
  //   }, 1);
  // });

  $('.button-iprt-view').on('click', function (e) {
    e.preventDefault();

    const view = $(this).data('view');
    const params = new URLSearchParams(window.location.search);
    params.set("view", view);

    // console.log('params.toString()', params.toString());

    // if (params.toString() == "view=canvas") {
    //   document.getElementById("iprt-page-transition").style.backgroundColor = "##F0EDE7";
    // }
    
    // if (params.toString() == "view=map") {
    //   document.getElementById("iprt-page-transition").style.backgroundColor = "#D0D6D6";
    // }
      
    document.getElementById("iprt-page-transition").style.backgroundColor = "##F0EDE7";
    document.getElementById("iprt-page-transition").style.display = "block";
    document.getElementById("iprt-page-transition").style.pointerEvents = "auto";

    setTimeout(() => {
      document.getElementById("iprt-page-transition").classList.add("active");

      setTimeout(() => {
        window.open('/praktijkervaring?' + params.toString(), '_self');
      }, 1500);
    }, 1);
  });


  function updateFavCount() {
    const favourites = JSON.parse(localStorage.getItem("inspiratie-favourites")) || [];
    $(".fav-count").text(`Favorieten (${favourites.length})`);
  }

  // Run on page load
  updateFavCount();


  $("#add-favorieten").on("click", function () {
    const btn = $(this);
    const nodeId = btn.data("fav");
    let favourites = JSON.parse(localStorage.getItem("inspiratie-favourites")) || [];

    const iconOutline = btn.data("icon-outline");
    const iconFilled = btn.data("icon-filled");

    console.log("pink", iconFilled);

    if (favourites.includes(nodeId)) {
      // Remove from favourites
      favourites = favourites.filter(id => id !== nodeId);
      btn.find("span").text("Opslaan als favoriet");
      btn.removeClass("active");
      btn.find("img").attr("src", iconOutline);
    } else {
      // Add to favourites
      favourites.push(nodeId);
      btn.find("span").text("Verwijderen uit favorieten");
      btn.addClass("active");
      btn.find("img").attr("src", iconFilled);
    }

    // Save back to LocalStorage
    localStorage.setItem("inspiratie-favourites", JSON.stringify(favourites));
    updateFavCount();
  });

  // On page load → update button state if already in favourites
  const btn = $("#add-favorieten");
  const nodeId = btn.data("fav");
  let favourites = JSON.parse(localStorage.getItem("inspiratie-favourites")) || [];

  if (favourites.includes(nodeId)) {
    btn.find("span").text("Verwijderen uit favorieten");
    btn.addClass("active");
    btn.find("img").attr("src", btn.data("icon-filled"));
  } else {
    btn.find("img").attr("src", btn.data("icon-outline"));
  }


  $('#button-filter-mobile').on('click', function(){
    const elm = $(this);
    const expanded = elm.attr('aria-expanded') === 'true' || false;
    elm.attr('aria-expanded', !expanded);
    const panel = $('#inspiratiepunten-filter-panel');
    panel.toggleClass('hidden');

    if (!expanded) {
      elm.find('img').css('transform', 'rotate(180deg)');
    } else {
      elm.find('img').css('transform', 'none');
    }
  });

});
